<template>
  <div class="main">
    <div class="title">
      <div class="name">专家信息</div>
    </div>
    <div class="tab">
      <span @click="to">+ 新增专家</span>
      <span>
        <el-upload
            class="avatar-uploader"
            accept=".xlsx"
            :action="baseURL + daoru"
            :data="Data"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
             专家导入
        </el-upload>
      </span>
      <span><a :href="baseURL + daochu + 'mid=' + user.mid+ '&search_type='+ search.value +'&search_name=' + search.input" target="_blank" download>专家导出</a></span>
      <span><a :href="muban" target="_blank" download>模板下载</a></span>
    </div>
    <div class="list-box">
      <div class="search-box">
        <div class="select-box">
          <el-select v-model="search.value" clearable placeholder="请选择专家分类">
            <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="input-box">
          <el-input v-model="search.input" placeholder="请输入专家姓名" style="width: 100%;"></el-input>
          <div @click="list">
            <i class="iconfont icon-sousuo"></i>
            <span>搜索</span>
          </div>
        </div>
        <div class="chongz" @click="reset">重置</div>
      </div>
      <el-table
          :data="tableData"
          border
          :header-cell-style="{
            'text-align':'center',
            'height':'58px',
            'background-color':'#dae0e6',
            'color':'#333'}"
          :cell-style="{'text-align':'center'}"
          style="width: 100%;border-radius: 10px;">
        <el-table-column
            type="index"
            label="序号"
            width="50">
        </el-table-column>
        <el-table-column
            prop="name"
            label="专家姓名"
            width="80">
        </el-table-column>
        <el-table-column
            prop="type_text"
            label="领域"
            width="130">
        </el-table-column>
        <el-table-column
            prop="job_text"
            label="职务"
            width="140">
        </el-table-column>
        <el-table-column
            label="简介"
            width="220">
          <template slot-scope="scope">
            <div class="ovHide3" v-html="scope.row.desc"></div>
          </template>
        </el-table-column>
        <el-table-column
            label="照片"
            width="90">
          <template slot-scope="scope">
            <img :src="urlStr + scope.row.pic" alt="" style="width: 65px;height: 77px;object-fit: scale-down">
<!--            <img v-else src="../../../assets/images/moren.png" alt="" style="width: 65px;height: 77px;object-fit: scale-down">-->
          </template>
        </el-table-column>
        <el-table-column
            label="是否显示"
            width="90">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is_show"
              :active-value="1"
              :inactive-value="0"
              @change="showload($event,scope.row.id)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
            label="操作">
          <template slot-scope="scope">
            <div class="flex justify-between flex-wrap">
              <el-button
                  size="small"
                  type="primary"
                  class="edit"
                  style="width: 150px;margin-top: 0;"
                  round
                  @click="yuyue(scope.row.id)">预约信息({{scope.row.yuyue_count}})</el-button>
              <el-button
                  size="small"
                  type="primary"
                  class="edit"
                  round
                  @click="go(scope.row.id)">编辑</el-button>
              <el-button
                  size="small"
                  class="del"
                  round
                  @click="handleDelete(scope.row.id)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import {expertDel, Expertlist, getExpertType, expertSetShow, getMoBAN, getSetting} from "@/api/index";
import {baseURL, urlStr} from "@/config";
export default {
  name: "detail",
  data() {
    return {
      urlStr: urlStr,
      baseURL:baseURL,
      oid:'',
      Data:{
        mid:''
      },
      daochu:'/api/expert/exportToExcel?',
      daoru:'/api/expert/importByExcel',
      muban:'',
      active:1,
      id:'',
      search:{
        value:'',
        input:''
      },
      options: [],
      tableData: []
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {},
  created() {
    this.$emit("setActive", {
      active: 1,
      act: 2,
      name: '专家管理 > 专家信息'
    })
    this.Data.mid = this.user.mid
    this.getSetting()
    this.getExpertType()
    this.list()
    this.getBAN()
  },
  methods: {
    handleDelete(id) {
      this.$confirm('此操作将删除该数据，是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.expertDel(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    async getSetting() {
      let _res = await getSetting(
          this.user.mid
      );
      if (_res.status === 200) {
        this.oid =  _res.data.setting.oid
      } else {
        this.$message.error(_res.msg)
      }
    },

    // 删除专家
    async expertDel(id){
      let _res = await expertDel(
          this.user.mid,
          id
      );
      if(_res.status === 200){
        this.$message.success(_res.msg);
        this.list()
      }else {
        this.$message.error(_res.msg);
      }
    },

    // 获取列表
    async list() {
      let _res = await Expertlist(
          this.user.mid,
          1,
          this.search.value,
          this.search.input,
          1,999
      );
      if (_res.status === 200) {
        this.tableData = _res.data
        _res.data.map(item => {
          let ary = JSON.parse(item.job)
          let arr = []
          ary.map(itm => {
            arr.push(itm.value)
          })
          item.job_text = arr.join('、')
        })
      } else {
        this.$message.error(_res.msg)
      }
    },

    // 获取分类
    async getExpertType(){
      let _res = await getExpertType(
          this.user.mid
      );
      if(_res.status === 200){
        this.options = _res.data
      }else {
        this.$message.error(_res.msg);
      }
    },

    // 显示隐藏
    async showload(bool,id){
      console.log(bool)
      let _res = await expertSetShow(
          this.user.mid,
          id
      );
      if(_res.status === 200){
        this.$message.success(_res.msg);
        this.list()
      }else {
        this.$message.error(_res.msg);
      }
    },

    // 获取模板链接
    async getBAN() {
      let _res = await getMoBAN(
          this.user.mid
      );
      if (_res.status === 200) {
        this.muban = _res.data.url
      } else {
        this.$message.error(_res.msg)
      }
    },

    //  上传成功
    handleAvatarSuccess(response) {
      this.uping.close();
      if (response.status === 200) {
        this.$message.success(response.msg)
        this.list()
      } else {
        this.$message.success(response.msg)
      }
    },
    //  上传失败
    uploadError() {
      this.uping.close();
      this.$message({
        message: "上传出错，请重试！",
        type: "error",
        center: true,
      });
    },

    beforeAvatarUpload() {
      this.uping = this.$loading({
        lock: true,
        text: "上传中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
      });
    },

    reset(){
      this.search.value = ''
      this.search.input = ''
      this.list()
    },

    go(id){
      this.$router.push({
        path:'/home/examineDetail',
        query:{
          id:id,
          act:2
        }
      })
    },

    to(){
      this.$router.push({
        path:'/checkin',
        query:{
          register_type:2,
          showId:this.oid
        }
      })
    },

    yuyue(id){
      this.$router.push({
        path:'/home/detailYuyue',
        query:{
          id:id
        }
      })
    }
  },
  watch: {

  },
  filters: {}
}
</script>

<style scoped lang="scss">
.show{
  width: 70px;
  height: 30px;
  background-color: #ff9600;
  border: 1px solid #ff9600;
  line-height: 28px;
  padding: 0;
  border-radius: 15px;
  color: #ffffff;
  margin-top: 5px;
}
.hide{
  width: 70px;
  height: 30px;
  background-color: #dae0e6;
  border: 1px solid #dae0e6;
  line-height: 28px;
  padding: 0;
  border-radius: 15px;
  color: #ffffff;
  margin-top: 5px;
}
.del {
  width: 70px;
  height: 30px;
  border-radius: 15px;
  border: solid 1px #0a2240;
  line-height: 28px;
  padding: 0;
  color: #0a2240;
  margin-left: 0;
  margin-top: 5px;
}
.edit {
  width: 70px;
  height: 30px;
  background-color: #0a2240;
  line-height: 28px;
  padding: 0;
  border-radius: 15px;
  margin-top: 5px;
  margin-left: 0;
}
.main {
  display: flex;
  flex-direction: column;
  .title {
    padding: 5px 8px 15px 8px;
    .name {
      font-size: 20px;
      color: #ffffff;
      font-weight: bold;
    }
  }

  .tab {
    width: 100%;
    display: flex;
    justify-content: space-between;
    background-color: #ffffff;
    padding: 10px;
    border-radius: 10px;
    span {
      width: 236px;
      height: 50px;
      background-color: #f3f7fb;
      border-radius: 10px;
      border: solid 1px #dae0e6;
      font-size: 18px;
      color: #0a2240;
      text-align: center;
      line-height: 48px;
      cursor: pointer;
      a {
        font-size: 18px;
        color: #0a2240;
      }
      &:hover {
        background-color: #ff9600;
        border: solid 1px #ff9600;
        color: #ffffff;
        a {
          color: #ffffff;
        }
      }
    }
  }

  .list-box {
    width: 100%;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 15px;
    margin-top: 20px;
    flex: 1;

    .search-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      .select-box {
        width: 162px;
      }
      .chongz {
        width: 99px;
        height: 40px;
        background-color: #0a2240;
        border-radius: 5px;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
        text-align: center;
        line-height: 40px;
      }
      .input-box {
        flex: 1;
        width: 0;
        margin: 0 15px;
        display: flex;
        height: 40px;
        overflow: hidden;
        justify-content: space-between;
        border-radius: 5px;

        > div {
          width: 100px;
          height: 40px;
          background-color: #0a2240;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          span {
            font-size: 16px;
            color: #ffffff;
          }
          i {
            margin-right: 4px;
            color: #ffffff;
            font-size: 18px;
          }
        }
      }
    }

  }
}
</style>


